import { axiosInstance } from "../lib/axios";

export const validateToken = async (): Promise<boolean> => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      return false;
    }

    // Make a simple API call to check if token is valid
    // You can adjust this endpoint based on your backend
    const response = await axiosInstance.get("api/Auth/validate-token");
    
    return response.status === 200;
  } catch (error: any) {
    // If token is invalid, the axios interceptor will handle logout
    console.warn("Token validation failed:", error.message);
    return false;
  }
};

export const checkTokenExpiry = (): boolean => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      return false;
    }

    // Decode JWT token to check expiry (basic check)
    const tokenPayload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    
    // Check if token is expired
    if (tokenPayload.exp && tokenPayload.exp < currentTime) {
      console.warn("Token has expired");
      return false;
    }
    
    return true;
  } catch (error) {
    console.warn("Error checking token expiry:", error);
    return false;
  }
};

// Check token expiry with buffer (5 minutes before actual expiry)
export const isTokenExpiringSoon = (): boolean => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      return true;
    }

    const tokenPayload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    const bufferTime = 5 * 60; // 5 minutes buffer
    
    // Check if token expires within 5 minutes
    if (tokenPayload.exp && (tokenPayload.exp - bufferTime) < currentTime) {
      console.warn("Token expires soon");
      return true;
    }
    
    return false;
  } catch (error) {
    console.warn("Error checking token expiry buffer:", error);
    return true;
  }
};
